/**
 * Redux store configuration.
 *
 * - RTK Query middleware powers caching, invalidation, and refetching.
 * - listenerMiddleware handles cross-cutting side effects.
 * - replaceReducer + registerReducer enable lazy slice injection so feature
 *   state code-splits with the feature bundle.
 */
import { configureStore } from '@reduxjs/toolkit';

import { env } from '@config/env';
import { baseApi } from '@services/baseApi';

import { listenerMiddleware } from './listenerMiddleware';
import { combine, registerReducer } from './rootReducer';

export const store = configureStore({
  reducer: combine(),
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: { ignoredActions: ['api/executeQuery/fulfilled'] },
    })
      .prepend(listenerMiddleware.middleware)
      .concat(baseApi.middleware),
  devTools: env.isDev,
});

/**
 * Inject a feature reducer at runtime and rebuild the root reducer.
 * Idempotent: safe to call on every feature load.
 */
export function injectReducer(key, reducer) {
  if (registerReducer(key, reducer)) {
    store.replaceReducer(combine());
  }
}
